import styles from "./LoyaltyPointsExchanges.module.scss";
import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import {LoyaltyPointsService} from "../../services/loyaltyPoints.service";
import {ICustomerLoyaltyBalance, ILoyaltyPointsExchangesForCustomer} from "../../models/LoyaltyPoints";
import useAppSelector from "../../hooks/useAppSelector";

interface ILoyaltyPointsExchangesProps {
    itemPrice: number | null;
    setActiveLoyaltyExchangeId: (id: number | null) => void;
    activeLoyaltyExchangeId: number | null;
}

const LoyaltyPointsExchanges: React.FC<ILoyaltyPointsExchangesProps> = ({itemPrice, setActiveLoyaltyExchangeId, activeLoyaltyExchangeId}) => {

    const {t} = useTranslation();
    const {gymSettings} = useAppSelector(state => state.gymSettingsSlice);
    const {profile} = useAppSelector(state => state.profileSlice);
    const [loyaltyExchanges, setLoyaltyExchanges] = useState<ILoyaltyPointsExchangesForCustomer[]>([]);
    const [customerBalance, setCustomerBalance] = useState<ICustomerLoyaltyBalance | null>(null);

    useEffect(() => {
        getLoyaltyPointsExchanges();
        getCustomerBalance();
    }, []);

    const getLoyaltyPointsExchanges = async () => {
        try {
            const response = await LoyaltyPointsService.getExchangesForCustomer();
            setLoyaltyExchanges(response.data.data);
        } catch (e) {}
    }

    const getCustomerBalance = async () => {
        if (!profile) return;
        try {
            const response = await LoyaltyPointsService.getCustomersLoyaltyPointsBalance(profile.customerId);
            setCustomerBalance(response.data.data);
        } catch (e) {}
    }

    const renderItem = (el: ILoyaltyPointsExchangesForCustomer) => {
        if (!customerBalance) return;

        let isItemDisabled = true;
        if (itemPrice) {
            isItemDisabled = customerBalance?.loyaltyPointsBalance < el.numberOfPoints || el.userReceive >= itemPrice;
        }

        const clickOnLoyaltyExchangeId = (id: number) => {
            if (isItemDisabled) return;
            if (id === activeLoyaltyExchangeId) {
                setActiveLoyaltyExchangeId(null);
            } else {
                setActiveLoyaltyExchangeId(id);
            }
        }

        const itemText = `${el.numberOfPoints} ${t("PointsFor")} ${gymSettings?.defaultCurrencyCode}${el.userReceive}`;

        let itemClass;
        if (isItemDisabled) {
            itemClass = styles.disabled;
        } else if (activeLoyaltyExchangeId === el.id) {
            itemClass = styles.active;
        }

        return (
            <div key={el.id} onClick={() => clickOnLoyaltyExchangeId(el.id)} className={`${styles.item} ${itemClass}`}>
                <p>{itemText}</p>
            </div>
        )
    }

    return (
        <div className={styles.component}>
            <p className={styles.label}>{t("LoyaltyPoints")}</p>
            <div className={styles.wrapper}>
                {loyaltyExchanges.map(el => renderItem(el))}
            </div>
        </div>
    )
}

export default LoyaltyPointsExchanges;